export default "__VITE_ASSET__hoQvCWk7__"